/*
* @Description: 质量模板
* @Author: yjx
* @Date: 2021-11-19 18:22:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-04 11:56:10
*/
import request from '@/utils/request'
// 获取公司质量参数
export function getQualityDetection1(data) {
  return request({
    url: '/icps/system/basics/qualityDetectionCompany/getQualityDetection',
    method: 'post',
    data
  })
}
// 保存修改公司质量参数
export function saveOrUpdate1(data) {
  return request({
    url: '/icps/system/basics/qualityDetectionCompany/saveOrUpdate',
    method: 'post',
    data
  })
}
// 获取站点质量参数
export function getQualityDetection2(data) {
  return request({
    url: '/icps/system/basics/qualityDetectionStation/getQualityDetection',
    method: 'post',
    data
  })
}
// 保存修改站点质量参数
export function saveOrUpdate2(data) {
  return request({
    url: '/icps/system/basics/qualityDetectionStation/saveOrUpdate',
    method: 'post',
    data
  })
}

// 保存修改交工资料
export function saveOrUpdate3(data) {
    return request({
        url: '/icps/system/sign/basics/handoverDataStandard/saveOrUpdate',
        method: 'post',
        data
    })
}

// 获取交工资料
export function queryStand(data) {
    return request({
        url: '/icps/system/sign/basics/handoverDataStandard/queryStand',
        method: 'post',
        data
    })
}

